import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { libraryShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import TagsActions from 'app/actions/TagsActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectTagSummariesByBib } from 'app/selectors/ugc/TagsSelector';
import AllCommunityTags from './AllCommunityTags';

export class AllCommunityTagsContainer extends React.PureComponent {
  componentDidMount() {
    const { tagsActions, metadataId } = this.props;
    tagsActions.fetchTagSummaries(metadataId);

    if (this.props.currentUser?.get('staff')) {
      tagsActions.fetchOwnerTags(metadataId);
    }
  }

  render() {
    return <AllCommunityTags {...this.props} />;
  }
}

AllCommunityTagsContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentUser: userIdentityShape
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  tags: selectTagSummariesByBib(state),
  currentUser: selectCurrentUser(state)
});

const mapDispatchToProps = dispatch => ({
  tagsActions: bindActionCreators(TagsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllCommunityTagsContainer);
